import React from "react";
import { motion } from "framer-motion";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaLeaf, FaWater, FaArrowRight, FaSpa } from "react-icons/fa"; // Nature Icons

import Navr from "../Navbar/Navr";
import Footer from "../Components2/Footer";

// Images Import
// Note: Maine variable names change kiye hain taaki code readable rahe
import heroImg from "../Ecomphotos/alpy.jpg"; // Yahan Kerala ki backwater image lagana best rahega
import alleppeyImg from "../Ecomphotos/alp.jpg";
import kochiImg from "../Ecomphotos/kochi.jpg";
import kovalamImg from "../Ecomphotos/kov.jpg";
import wayanadImg from "../Ecomphotos/wayanad.jpg";

export default function Kerala() {
  // Data Array
  const destinations = [
    { id: 1, name: "Alleppey", img: alleppeyImg, desc: "Venice of the East" },
    { id: 2, name: "Kochi", img: kochiImg, desc: "Queen of Arabian Sea" },
    { id: 3, name: "Kovalam", img: kovalamImg, desc: "Beach Paradise" },
    { id: 4, name: "Wayanad", img: wayanadImg, desc: "Land of Paddy Fields" },
  ];

  return (
    <div className="kerala-page">
      <Navr />

      {/* --- Section 1: Hero Banner (Green & Serene) --- */}
      <div
        className="kerala-hero d-flex align-items-center justify-content-center"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="overlay-green"></div>
        <Container className="text-center position-relative z-2">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            <h5 className="text-warning text-uppercase ls-2 mb-3">
              God's Own Country
            </h5>
            <h1 className="display-2 fw-bold text-white mb-4">
              Kerala Tour Packages
            </h1>
            <p
              className="text-white lead mx-auto"
              style={{ maxWidth: "700px" }}
            >
              Immerse yourself in the tranquility of backwaters, lush hills, and
              pristine beaches.
            </p>
          </motion.div>
        </Container>
      </div>

      {/* --- Section 2: Intro / About --- */}
      <section className="py-5 bg-white position-relative overflow-hidden">
        {/* Decorative Background Leaf */}
        <FaLeaf className="bg-icon-leaf" />

        <Container>
          <Row className="align-items-center my-4">
            <Col lg={7} className="mb-4 mb-lg-0 z-2">
              <h6 className="text-success fw-bold text-uppercase">
                Welcome to Nature
              </h6>
              <h2 className="mb-4 fw-bold text-dark display-6">
                Experience Serenity
              </h2>

              <p className="text-muted text-justify lead-sm">
                Experience the lush beauty and serene backwaters of Kerala with
                our specially designed tour package. Explore the enchanting
                houseboats of <strong>Alleppey</strong>, the misty hills of{" "}
                <strong>Munnar</strong>, and the vibrant culture of{" "}
                <strong>Kochi</strong>.
              </p>
              <p className="text-muted text-justify lead-sm">
                Enjoy traditional Kathakali performances, soothing{" "}
                <strong>Ayurvedic treatments</strong>, and authentic Kerala
                cuisine. From tranquil backwaters to breathtaking hill stations,
                every moment in Kerala is filled with natural beauty.
              </p>

              <div className="d-flex gap-3 mt-4">
                <div className="feature-badge">
                  <FaWater className="text-success mb-1" />
                  <span>Backwaters</span>
                </div>
                <div className="feature-badge">
                  <FaSpa className="text-success mb-1" />
                  <span>Ayurveda</span>
                </div>
              </div>

              <Link
                to="/contact"
                className="btn btn-success px-4 py-2 mt-4 rounded-pill shadow fw-bold"
              >
                Book Your Escape <FaArrowRight className="ms-2" />
              </Link>
            </Col>

            <Col lg={5} className="z-2">
              <div className="organic-frame">
                <img
                  src={heroImg}
                  className="img-fluid shadow-lg"
                  alt="Kerala Boat"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* --- Section 3: Destinations Grid --- */}
      <section className="py-5 bg-light-green">
        <Container>
          <div className="text-center mb-5">
            <h6 className="text-success fw-bold text-uppercase">
              Top Attractions
            </h6>
            <h2 className="fw-bold display-6">Explore the Gems of Kerala</h2>
            <div className="leaf-divider mx-auto text-success">
              <FaLeaf />
            </div>
          </div>

          <Row className="g-4">
            {destinations.map((place) => (
              <Col md={6} lg={3} key={place.id}>
                <div className="nature-card h-100">
                  <div className="card-img-top">
                    <img src={place.img} alt={place.name} />
                  </div>
                  <div className="card-body p-4 text-center">
                    <h4 className="fw-bold text-dark mb-1">{place.name}</h4>
                    <p className="text-muted small mb-0">{place.desc}</p>
                    <hr className="short-hr mx-auto my-3" />
                    <Link
                      to="/contact"
                      className="text-success text-decoration-none fw-bold small"
                    >
                      View Details
                    </Link>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* --- Section 4: Green CTA --- */}
      <section className="cta-kerala py-5 text-center text-white">
        <Container>
          <h2 className="fw-bold mb-3">Relax, Rejuvenate, Rejoice</h2>
          <p className="lead mb-4 opacity-75">
            Your perfect Ayurvedic retreat is just a click away.
          </p>
          <Link
            to="/Contact"
            className="btn btn-light text-success btn-lg rounded-pill px-5 fw-bold shadow hover-lift"
          >
            Plan My Trip
          </Link>
        </Container>
      </section>

      <Footer />
    </div>
  );
}
